import * as moment from "moment";
import {none, option, Option} from "ts-option";
import {NoteApiDto} from "../../api/model/rest";
import AuthenticatedEntity from "../user/AuthenticatedEntity";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import ActivityEvent from "../event/ActivityEvent";
import Attachment from "../attachment/Attachment";
import PinningData from "./PinningData";

/**
 * Note model.
 */
export default class Note extends ActivityEvent {

	constructor(public readonly id: string,
		public readonly creator: AuthenticatedEntity,
		public readonly content: string,
		public readonly extendedContent: string,
		public readonly creationDate: moment.Moment,
		public readonly updateDate: Option<moment.Moment>,
		public readonly reminderDate: Option<moment.Moment>,
		public readonly pinningData: PinningData) {
		super();
	}

	getCssClass(differentContext?: boolean) {
		let cssClass = '';
		if (!this.isReminder() && this.pinningData.pinned && !differentContext) {
			cssClass = cssClass + ' pinned-note';
		}
		return cssClass;
	}

	getIcon() {
		return this.isReminder() ? Icon.Reminder : Icon.Note;
	}

	getIconColor(): IconColor {
		return this.isReminder() ? IconColor.Yellow : IconColor.NoteYellow;
	}

	getAttachments(): Attachment[] {
		return [];
	}

	getActivityAdditionalMessages(): string[] {
		return [];
	}

	getActivityType(differentContext?: boolean): string {
		if (this.isReminder()) {
			return 'REMINDER';
		}
		else if (this.pinningData.pinned && !differentContext) {
			return 'PINNED NOTE';
		}
		else {
			return 'NOTE';
		}
	}

	getActivityMessage(): string {
		return "";
	}

	getCreationDate(): moment.Moment {
		return this.creationDate;
	}

	isReminder() {
		return this.reminderDate.isDefined;
	}

	getId() {
		return this.id;
	}

	getUserDisplayName(): string {
		return this.creator.getDisplayName();
	}

	static fromJson(json: NoteApiDto): Note {
		const creationDate = moment(json.creationDate);
		const updateDate = json.updateDate ? option(moment(json.updateDate)) : none;
		const reminderDate = json.reminderDate ? option(moment(json.reminderDate)) : none;
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new Note(json.id, creator, json.content, json.extendedContent, creationDate, updateDate, reminderDate,
			PinningData.fromJson(json.pinningData))
	}

	copy({
		id = this.id,
		creator = this.creator,
		content = this.content,
		extendedContent = this.extendedContent,
		creationDate = this.creationDate,
		updateDate = this.updateDate,
		reminder = this.reminderDate,
		pinningData = this.pinningData
	}) {
		return new Note(id, creator, content, extendedContent, creationDate, updateDate, reminder, pinningData);
	}
}